/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateTagDetailsRequest } from './createTagDetailsRequest';

export interface CreateTagRequest { 
    value: string;
    colorCode: string;
    fill: boolean;
    screenshot: boolean;
    translate: boolean;
    langs: Array<CreateTagRequest.LangsEnum>;
    details: Array<CreateTagDetailsRequest>;
    categoryId: string;
}
export namespace CreateTagRequest {
    export type LangsEnum = 'MK' | 'EN' | 'AL';
    export const LangsEnum = {
        MK: 'MK' as LangsEnum,
        EN: 'EN' as LangsEnum,
        AL: 'AL' as LangsEnum
    };
}